import { param } from "jquery";
import axiosInstance from "../utils/axios";

export const getMyAllExamCountService = async (exam = 0) => {
  return await axiosInstance().get(`/getMyAllExamCount`, {
    params: { examType: "in_progress", exam: exam },
  });
};
